import { getEnvironmentInfo } from './satu-event-get-env'

const eventName = 'aum_ce_web_portal_ult_tracker_v1'

export async function trackSatuEvent(data: any) {
  try {
    const envInfo = getEnvironmentInfo()
    const combinedData = {
      ...envInfo,
      ...data,
    }

    const payload = JSON.stringify({
      eventName,
      data: combinedData,
    })

    // Use sendBeacon for reliable tracking, especially on navigation
    // sendBeacon persists even after page navigation/redirect
    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
      const blob = new Blob([payload], { type: 'application/json' })
      navigator.sendBeacon('/api/satu-event-tracker/track', blob)
    } else {
      // Fallback for browsers without sendBeacon support
      const response = await fetch('/api/satu-event-tracker/track', {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: payload,
        keepalive: true, // Important for fetch on navigation
      })

      if (!response.ok) {
        console.error(
          'Error tracking event:',
          response.status,
          await response.text()
        )
        return
      }
    }
  } catch (error) {
    console.error('Error tracking event:', error)
  }
}
